//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    tabs: {
      type: Array,
      default: [],
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    /**
     * @description 点击切换tab
     */
    handleClick(item) {
      this.model = item.value;
      this.$emit('change', item);
    },
  },
};
